import type { LoggerOptions } from "pino";

/** Shared base config for all pino instances */
export const loggerConfig: LoggerOptions = {
  level: "info",
  redact: {
    paths: [
      "password",
      "token",
      "apiKey",
      "secret",
      "authorization",
      "credentials",
    ],
    censor: "[REDACTED]",
  },
};

export type { Logger } from "pino";
